import React from 'react'
import { cn, SubHeader } from '@yanolja-rnd/nol-design-system'
import { IcError } from '@yanolja-rnd/nol-icons'
import { toKRW, toPoint } from '~/api/utils/krNumberToString'
import getNolPointsToBeEarned from '~/app/utils/getNolPointsToBeEarned'

interface OrderSummaryCardProps {
  maxDiscountAmount: number
  maxDiscountTypeName: string
  isTimeout: boolean
  isMaxLengthExceeded: boolean
  totalPrice: number
  expectedPayAmount: number
  isNolCardLinked?: boolean
  className?: string
}

const OrderSummaryCard: React.FC<OrderSummaryCardProps> = ({
  maxDiscountAmount,
  maxDiscountTypeName,
  isTimeout,
  isMaxLengthExceeded,
  isNolCardLinked = false,
  totalPrice,
  expectedPayAmount,
  className,
}) => {
  const errorText = isTimeout
    ? '할인 금액을 불러오지 못했습니다'
    : isMaxLengthExceeded
      ? '예약 시 쿠폰할인에서 확인해 주세요'
      : ''

  const discountLabel = maxDiscountAmount > 0 ? maxDiscountTypeName : '할인 금액'

  const nolPointsInfo = getNolPointsToBeEarned(expectedPayAmount)

  return (
    <div className={cn('bg-static-white before:shrink-0', className)}>
      <SubHeader.Fixed title="예약 상품" />

      <div className="border-b border-dashed border-b-line-neutral-weak3">
        <div className="flex items-center justify-between py-8">
          <span className="typography-body-14-regular">상품 금액</span>
          <span className="typography-body-14-bold">{toKRW(totalPrice)}</span>
        </div>

        <div className="mb-16 flex items-center justify-between py-8">
          <span className="typography-body-14-regular">{discountLabel}</span>
          {errorText ? (
            <span className="flex items-center gap-2 text-text-warning-main typography-body-14-bold">
              <IcError height={18} width={18} />
              {errorText}
            </span>
          ) : (
            <span className="typography-body-14-regular">-{toKRW(maxDiscountAmount)}</span>
          )}
        </div>
      </div>

      <div className="my-16 py-8">
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 typography-subtitle-16-bold">
            결제 예상 금액
          </span>
          <span className="typography-subtitle-20-bold">{toKRW(expectedPayAmount)}</span>
        </div>
      </div>

      <div className="flex min-h-40 items-center justify-center rounded-12 bg-fill-warning-weak px-16 py-4">
        <p className="typography-body-13-regular">
          NOL 카드 결제 시,{' '}
          <span className="text-text-accent-medium typography-body-13-bold">
            {isNolCardLinked ? `최대 ${toPoint(nolPointsInfo.nolPoints)}` : '10%'} 적립
          </span>
        </p>
      </div>
    </div>
  )
}

export default OrderSummaryCard
